// Tabulkové zobrazení (desktop) a detail auditu.
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)
import { DELETED_RETENTION_DAYS, ICONS, auditGroupFilterFieldHtml, auditGroupOfType, auditNoLabel, auditNoSortKey, auditNoValue, cachedValue, canManageContent, cascadeDeleteAudits, collectAttachmentIdsForAudits, correctiveActionKeysForAudits, esc, fmtDate, fmtDateShort, matchesAuditGroup, normalizeSearchText, queueWrite, scopeBadgeHtml, scopeToggleHtml, filterActionsHtml, showToast, sortedAuditTypes, sortedWorkplaces, state, typesInGroup, auditAbsentNames, auditPresentNames, auditAuditorLabel, wpFilterFieldsHtml } from '../core/state.js';
import { deletedAudits, hardDeleteAudit, paginateList, paginationControlsHtml } from '../core/pagination.js';
import { db, downloadsCap } from '../core/boot.js';
import { setScopeSilent } from '../core/companies.js';
import { confirmRow } from '../core/chrome.js';
import { correctiveResolvedAt, daysSince } from './dashboard.js';
import { isDesktopLayout, wireDateFilter } from './my-tasks.js';
import { settingsHeadHtml } from '../core/ui-kit.js';
import { auditScorePercent, auditUsesOkNok, auditUsesPercent, auditsHeadHtml, correctiveReadOnlyHtml, findingsCountText, scorePercentHtml } from './audit-runner.js';
import { HISTORY_SORT_OPTIONS, filteredHistoryList, historyAuditorOptions, sortControlHtml } from './history.js';
import { AUDIT_STATUS_META, CORRECTIVE_STATUS_LABELS, CORRECTIVE_STATUS_RANK, allCorrectiveItems, auditCorrectiveLineHtml, auditResultBadgeHtml, correctiveCodeHtml, correctiveStatusBadgeHtml, isCorrectiveOverdue } from './corrective.js';
import { MONTH_NAMES_CS, csvBlob, historyMoreMenuHtml } from '../core/pdf.js';
import { dateTimeInputHtml, render } from '../main-render.js';

// ================= TABULKOVÉ ZOBRAZENÍ (desktop) =================
// Historie a Opatření mají na desktopu dvě zobrazení (volba v tomto
// prohlížeči): 'split' = seznam + náhled vedle, 'table' = tabulka jako
// v Excelu (řazení klikem na záhlaví, filtr u každého sloupce, stránkování,
// export CSV). Klik na řádek otevře detail jako samostatnou stránku.
// Stávající Filtry (Moje/Vše, …) a vyhledávání platí i pro tabulku.
var LIST_VIEW_KEYS = {history:'bozp-view-history', corrective:'bozp-view-corrective'};
var listViewMode = {history:'split', corrective:'split'};
try{ Object.keys(LIST_VIEW_KEYS).forEach(function(k){ if(localStorage.getItem(LIST_VIEW_KEYS[k])==='table') listViewMode[k] = 'table'; }); }catch(e){}
function isTableView(key){ return listViewMode[key]==='table' && isDesktopLayout(); }
App.setListView = function(key, mode){
  listViewMode[key] = mode==='table' ? 'table' : 'split';
  try{ localStorage.setItem(LIST_VIEW_KEYS[key], listViewMode[key]); }catch(e){}
  if(key==='history') state.historyDetailId = null; else state.correctiveDetailId = null;
  render();
};
function listViewToggleHtml(key){
  if(!isDesktopLayout()) return '';
  var m = listViewMode[key];
  return '<div class="view-toggle" role="group" aria-label="Zobrazení">' +
    '<button type="button" class="'+(m!=='table'?'on':'')+'" title="Seznam s náhledem" aria-label="Seznam s náhledem" aria-pressed="'+(m!=='table')+'" onclick="App.setListView(\''+key+'\',\'split\')">'+ICONS.viewSplit+'</button>' +
    '<button type="button" class="'+(m==='table'?'on':'')+'" title="Tabulka" aria-label="Tabulka" aria-pressed="'+(m==='table')+'" onclick="App.setListView(\''+key+'\',\'table\')">'+ICONS.viewTable+'</button></div>';
}
// Popisek tlačítka zpět v detailu podle zobrazení.
function detailBackLabel(key){
  if(!isDesktopLayout()) return '← Zpět';
  return isTableView(key) ? '← Zpět na tabulku' : 'Zavřít';
}
// Stav filtru/řazení tabulky v state: tblf_<tabulka>_<sloupec>[_from|_to],
// tbls_<tabulka> = {col, dir}.
function tblFilterKey(key, col, part){ return 'tblf_'+key+'_'+col+(part?'_'+part:''); }
App.setTblFilter = function(key, col, v){ state[tblFilterKey(key, col)] = v; render(); };
App.sortTbl = function(key, col){
  var s = state['tbls_'+key] || {};
  state['tbls_'+key] = (s.col===col) ? {col:col, dir: s.dir==='asc' ? 'desc' : 'asc'} : {col:col, dir:'asc'};
  render();
};
App.clearTblFilters = function(key, cols){
  cols.split(',').forEach(function(c){ ['', 'from', 'to'].forEach(function(p){ state[tblFilterKey(key, c, p)] = ''; }); });
  render();
};
function tblActiveFilterCount(key, cols){
  return cols.filter(function(c){
    return c.type==='date' ? (state[tblFilterKey(key,c.id,'from')] || state[tblFilterKey(key,c.id,'to')]) : state[tblFilterKey(key,c.id)];
  }).length;
}
// Vrátí řádky po filtrech sloupců a seřazené ({row, vals:[{v,t,h}]}).
function tblRows(key, cols, list){
  var rows = list.map(function(r){ return {row:r, vals: cols.map(function(c){ return c.get(r); })}; });
  var active = [];
  cols.forEach(function(c, i){
    if(c.type==='date'){
      var f = state[tblFilterKey(key,c.id,'from')], t = state[tblFilterKey(key,c.id,'to')];
      if(f || t) active.push(function(vals){
        var v = vals[i].v; if(v==null) return false;
        if(f && v < new Date(f+'T00:00:00').getTime()) return false;
        if(t && v > new Date(t+'T23:59:59').getTime()) return false;
        return true;
      });
    } else {
      var q = state[tblFilterKey(key,c.id)];
      if(!q) return;
      if(c.type==='select') active.push(function(vals){ return (vals[i].t||'')===q; });
      else { var nq = normalizeSearchText(q.trim()); active.push(function(vals){ return normalizeSearchText(vals[i].t||'').indexOf(nq)!==-1; }); }
    }
  });
  if(active.length) rows = rows.filter(function(r){ return active.every(function(fn){ return fn(r.vals); }); });
  var s = state['tbls_'+key], si = s ? cols.findIndex(function(c){ return c.id===s.col; }) : -1;
  if(si>=0){
    var dir = s.dir==='desc' ? -1 : 1;
    rows = rows.map(function(r, idx){ r.idx = idx; return r; }).sort(function(a, b){
      var av = a.vals[si].v, bv = b.vals[si].v;
      if(av==null || av==='') return (bv==null || bv==='') ? a.idx-b.idx : 1;   // prázdné vždy na konec
      if(bv==null || bv==='') return -1;
      var cmp = (typeof av==='string') ? av.localeCompare(bv, 'cs') : (av - bv);
      return cmp ? cmp*dir : a.idx-b.idx;
    });
  }
  return rows;
}
// Výběr a pořadí sloupců (tlačítko „Sloupce“) — uloženo k účtu:
// profiles/<já>.tableColumns = {history:[id…], corrective:[id…]} (jen
// zobrazené, v pořadí). Bez uložení = výchozí sloupce (def !== false).
// state.tblColsLocal drží změnu hned, než se profil znovu načte.
function tableColsPref(key){
  if(state.tblColsLocal && state.tblColsLocal.hasOwnProperty(key)) return state.tblColsLocal[key];
  var p = state.myId && state.profiles && state.profiles.get(state.myId);
  return (p && p.tableColumns && Array.isArray(p.tableColumns[key])) ? p.tableColumns[key] : null;
}
function visibleTableColumns(key, all){
  var pref = tableColsPref(key), byId = {};
  all.forEach(function(c){ byId[c.id] = c; });
  var cols = pref ? pref.map(function(id){ return byId[id]; }).filter(Boolean) : [];
  return cols.length ? cols : all.filter(function(c){ return c.def!==false; });
}
function saveTableCols(key, ids){
  state.tblColsLocal = state.tblColsLocal || {};
  state.tblColsLocal[key] = ids;
  if(db && state.myId){
    var p = state.profiles && state.profiles.get(state.myId);
    var merged = Object.assign({}, (p && p.tableColumns) || {});
    if(ids) merged[key] = ids; else delete merged[key];
    queueWrite(function(){ return db.doc('profiles/'+state.myId).update({tableColumns: merged}); });
  }
  render();
}
function tableAllColumns(key){ return key==='history' ? historyTableColumns() : correctiveTableColumns(); }
App.toggleTblColsPanel = function(key){ state['tblColsOpen_'+key] = !state['tblColsOpen_'+key]; render(); };
App.toggleTblCol = function(key, id, on){
  var all = tableAllColumns(key);
  var ids = visibleTableColumns(key, all).map(function(c){ return c.id; });
  var i = ids.indexOf(id);
  if(on && i===-1) ids.push(id);
  if(!on && i!==-1){
    if(ids.length<=1){ showToast('Aspoň jeden sloupec musí zůstat.'); render(); return; }
    ids.splice(i, 1);
  }
  saveTableCols(key, ids);
};
App.moveTblCol = function(key, id, dir){
  var ids = visibleTableColumns(key, tableAllColumns(key)).map(function(c){ return c.id; });
  var i = ids.indexOf(id), j = i + dir;
  if(i<0 || j<0 || j>=ids.length) return;
  ids.splice(j, 0, ids.splice(i, 1)[0]);
  saveTableCols(key, ids);
};
App.resetTblCols = function(key){ saveTableCols(key, null); };
function tableColsPanelHtml(key, all){
  var vis = visibleTableColumns(key, all), visIds = vis.map(function(c){ return c.id; });
  var hidden = all.filter(function(c){ return visIds.indexOf(c.id)===-1; });
  var rowHtml = function(c, i, isVis){
    return '<div class="dt-cols-row"><label class="check-row"><input type="checkbox" '+(isVis?'checked':'')+' onchange="App.toggleTblCol(\''+key+'\',\''+c.id+'\',this.checked)"/><span>'+esc(c.title||c.label)+'</span></label>' +
      (isVis ? '<span class="dt-cols-move">' +
        '<button type="button" class="icon-btn" title="Posunout doleva (nahoru)" aria-label="Posunout výš" '+(i===0?'disabled':'')+' onclick="App.moveTblCol(\''+key+'\',\''+c.id+'\',-1)">'+ICONS.up+'</button>' +
        '<button type="button" class="icon-btn" title="Posunout doprava (dolů)" aria-label="Posunout níž" '+(i===vis.length-1?'disabled':'')+' onclick="App.moveTblCol(\''+key+'\',\''+c.id+'\',1)">'+ICONS.down+'</button></span>' : '') +
      '</div>';
  };
  return '<div class="card dt-cols-panel"><div class="row-between" style="margin-bottom:6px"><b>Sloupce tabulky</b>' +
    '<span class="muted" style="font-size:var(--fs-sm)">Uloží se k vašemu účtu.</span></div>' +
    '<div class="dt-cols-list">' + vis.map(function(c, i){ return rowHtml(c, i, true); }).join('') +
    (hidden.length ? '<div class="dt-cols-sep muted">Skryté sloupce</div>' + hidden.map(function(c){ return rowHtml(c, 0, false); }).join('') : '') +
    '</div><div class="row-between" style="margin-top:10px">' +
    '<button type="button" class="link-btn" onclick="App.resetTblCols(\''+key+'\')">Obnovit výchozí</button>' +
    '<button type="button" class="btn btn-sm btn-primary" onclick="App.toggleTblColsPanel(\''+key+'\')">Hotovo</button></div></div>';
}
// cfg: key, cols (všechny), list (po Filtrech a hledání), rowClick(row) → JS, baseSig, noun
function dataTableHtml(cfg){
  var key = cfg.key, allCols = cfg.cols, cols = visibleTableColumns(key, allCols);
  var rows = tblRows(key, cols, cfg.list);
  var s = state['tbls_'+key] || {};
  var sig = JSON.stringify([cfg.baseSig, s, cols.map(function(c){ return [state[tblFilterKey(key,c.id)], state[tblFilterKey(key,c.id,'from')], state[tblFilterKey(key,c.id,'to')]]; })]);
  var pageKey = key+'TablePage';
  var page = paginateList(rows, pageKey, pageKey+'Sig', sig);
  var nActive = tblActiveFilterCount(key, cols);
  var html = '<div class="dt-meta"><span class="muted">'+rows.length+' '+cfg.noun(rows.length)+(rows.length!==cfg.list.length ? ' z '+cfg.list.length : '')+'</span>' +
    '<span style="display:flex;gap:12px;align-items:center">' +
    (nActive ? '<button type="button" class="link-btn" onclick="App.clearTblFilters(\''+key+'\',\''+cols.map(function(c){return c.id;}).join(',')+'\')">Zrušit filtry sloupců ('+nActive+')</button>' : '') +
    '<button type="button" class="btn btn-sm'+(state['tblColsOpen_'+key]?' on':'')+'" aria-expanded="'+(state['tblColsOpen_'+key]?'true':'false')+'" onclick="App.toggleTblColsPanel(\''+key+'\')">'+ICONS.viewTable+' Sloupce</button>' +
    '<button type="button" class="btn btn-sm" '+(rows.length?'':'disabled')+' onclick="App.exportTable(\''+key+'\')">'+ICONS.download+' Export CSV</button></span>' +
    // Panel sloupců = rozbalovací nabídka pod tlačítkem (tabulku neodsouvá).
    (state['tblColsOpen_'+key] ? tableColsPanelHtml(key, allCols) : '') + '</div>';
  html += '<div class="dt-wrap"><table class="dt"><thead><tr>' + cols.map(function(c){
    var on = s.col===c.id;
    return '<th class="'+(c.cls||'')+'"><button type="button" class="dt-sort'+(on?' on':'')+'" onclick="App.sortTbl(\''+key+'\',\''+c.id+'\')" title="Seřadit">'+esc(c.label) +
      '<span class="dt-sort-ind">'+(on ? (s.dir==='desc' ? '▼' : '▲') : '↕')+'</span></button></th>';
  }).join('') + '</tr><tr class="dt-filters">' + cols.map(function(c){
    var id = 'tf_'+key+'_'+c.id;
    if(c.type==='select'){
      var seen = {}, opts = [];
      cfg.list.forEach(function(r){ var t = c.get(r).t; if(t && !seen[t]){ seen[t]=true; opts.push(t); } });
      opts.sort(function(a,b){ return a.localeCompare(b,'cs'); });
      var cur = state[tblFilterKey(key,c.id)] || '';
      return '<th><select class="input-sm" id="'+id+'" aria-label="Filtr: '+esc(c.label)+'" onchange="App.setTblFilter(\''+key+'\',\''+c.id+'\',this.value)"><option value="">Vše</option>' +
        opts.map(function(o){ return '<option value="'+esc(o)+'" '+(cur===o?'selected':'')+'>'+esc(o)+'</option>'; }).join('') + '</select></th>';
    }
    if(c.type==='date'){
      return '<th><div class="dt-date">' +
        dateTimeInputHtml({id:id+'_from', value:state[tblFilterKey(key,c.id,'from')]||''}) +
        dateTimeInputHtml({id:id+'_to', value:state[tblFilterKey(key,c.id,'to')]||''}) + '</div></th>';
    }
    return '<th><input class="input-sm" id="'+id+'" aria-label="Filtr: '+esc(c.label)+'" placeholder="Filtr" value="'+esc(state[tblFilterKey(key,c.id)]||'')+'" oninput="App.setTblFilter(\''+key+'\',\''+c.id+'\',this.value)"/></th>';
  }).join('') + '</tr></thead><tbody>';
  if(!rows.length){
    html += '<tr><td colspan="'+cols.length+'" class="dt-empty muted">Žádné záznamy neodpovídají filtrům.</td></tr>';
  }
  page.items.forEach(function(r){
    html += '<tr tabindex="0" onclick="'+cfg.rowClick(r.row)+'" onkeydown="if(event.key===\'Enter\'){'+cfg.rowClick(r.row)+'}">' + r.vals.map(function(v, i){
      var c = cols[i];
      return '<td class="'+(c.cls||'')+'"'+(c.wrap ? ' title="'+esc(v.t||'')+'"' : '')+'>'+(v.h!=null ? v.h : esc(v.t||'—'))+'</td>';
    }).join('') + '</tr>';
  });
  html += '</tbody></table></div>' + paginationControlsHtml(pageKey, page);
  state['tblLast_'+key] = {cols:cols, rows:rows};
  return html;
}
// Datumová pole ve filtrech tabulky (bez onChange, viz pravidla polí data).
function wireTableDateFilters(key, cols){
  // Druhý řádek záhlaví (filtry) se lepí pod první — výška prvního řádku.
  var wrap = document.querySelector('.dt-wrap'), head = wrap && wrap.querySelector('thead tr');
  if(head) wrap.style.setProperty('--dt-head-h', Math.round(head.getBoundingClientRect().height)+'px');
  cols.forEach(function(c){
    if(c.type!=='date') return;
    ['from','to'].forEach(function(p){ wireDateFilter(document.getElementById('tf_'+key+'_'+c.id+'_'+p), tblFilterKey(key, c.id, p)); });
  });
}
App.exportTable = async function(key){
  if(!downloadsCap){ showToast('Stahování souborů není v tomto zobrazení dostupné.'); return; }
  var last = state['tblLast_'+key];
  if(!last || !last.rows.length){ showToast('Žádné záznamy k exportu.'); return; }
  var rows = [last.cols.map(function(c){ return c.label; })].concat(last.rows.map(function(r){ return r.vals.map(function(v){ return v.t || ''; }); }));
  var stamp = new Date().toISOString().slice(0,10);
  try{
    var res = await downloadsCap.save({filename:(key==='history'?'historie_':'opatreni_')+stamp+'.csv', data: csvBlob(rows)});
    if(res && res.status==='saved') showToast('CSV uloženo.');
  }catch(e){
    if(e && e.code==='declined'){ /* zrušeno */ } else { console.error('table export failed', e); showToast('Export se nezdařil.'); }
  }
};
App.openTableRow = function(key, id){
  if(key==='history'){ state.historyDetailId = id; state.historyDetailReturnTo = null; render(); }
  else App.openCorrectiveDetail(id);
  window.scrollTo(0, 0);
};
// Opatření po auditech jednou za překreslení (stav auditu v tabulce Historie).
function correctiveItemsByAudit(){
  return cachedValue('correctiveItemsByAudit', function(){
    var m = {};
    allCorrectiveItems().forEach(function(it){ (m[it.auditId] = m[it.auditId] || []).push(it); });
    return m;
  });
}
function auditStatusFromItems(a, items){
  var hasNok = !!(a && a.summary && (a.summary.nok>0 || a.summary.overall==='NOK'));
  if(!items.length) return hasNok ? 'nok' : 'closed';
  var open = items.filter(function(it){ return it.status!=='hotovo' && it.status!=='zruseno'; });
  if(!open.length) return 'closed';
  return open.some(isCorrectiveOverdue) ? 'overdue' : 'open';
}
// Dlouhý text v buňce tabulky zkrátit na max znaků („…“), celý v title;
// export CSV a filtry pracují s celým textem.
var TBL_MAX = {long:40, mid:22, name:24};
function tblShort(t, max, bold){
  t = t || '';
  var cut = t.length > max, s = cut ? t.slice(0, max-1).replace(/\s+$/,'')+'…' : t;
  var inner = esc(s || '—');
  if(bold) inner = '<b>'+inner+'</b>';
  return cut ? '<span title="'+esc(t)+'">'+inner+'</span>' : inner;
}
function tblText(t, max, bold){ t = t || ''; return {v:t, t:t, h:tblShort(t, max, bold)}; }
function tsOf(iso, dateOnly){ if(!iso) return null; var t = new Date(dateOnly ? iso+'T12:00:00' : iso).getTime(); return isNaN(t) ? null : t; }
function historyTableColumns(){
  var byAudit = correctiveItemsByAudit();
  function num(n){ return {v:n, t:n==null ? '' : String(n)}; }
  return [
    {id:'date', label:'Datum', type:'date', get:function(e){ var a=e[1]; return {v:tsOf(a.closedAt), t:a.closedAt ? fmtDateShort(a.closedAt) : ''}; }},
    {id:'num', label:'Č. auditu', type:'text', cls:'dt-num', get:function(e){ return {v:auditNoSortKey(e[1]), t:auditNoValue(e[1])}; }},
    {id:'wp', label:'Pracoviště', type:'select', get:function(e){ return tblText(e[1].workplaceName, TBL_MAX.mid, true); }},
    {id:'br', label:'Provozovna', type:'select', get:function(e){ return tblText(e[1].branchName||'Sídlo firmy', TBL_MAX.mid); }},
    {id:'type', label:'Druh auditu', type:'select', get:function(e){ return tblText(e[1].auditTypeName, TBL_MAX.mid); }},
    {id:'agroup', label:'Skupina auditů', type:'select', def:false, get:function(e){ return tblText(auditGroupOfType(e[1].auditTypeId), TBL_MAX.mid); }},
    {id:'auditor', label:'Auditor', type:'select', get:function(e){ return tblText(e[1].auditorName, TBL_MAX.name); }},
    {id:'result', label:'Výsledek', type:'select', get:function(e){
      var a=e[1], r = (a.summary && auditUsesOkNok(a)) ? (a.summary.overall||'') : '';
      return {v:r, t:r, h: r ? '<span class="badge '+(r==='OK'?'badge-ok':'badge-nok')+'">'+r+'</span>' : '<span class="muted">—</span>'}; }},
    {id:'score', label:'Skóre', type:'text', cls:'dt-num', get:function(e){
      var a=e[1], p = auditUsesPercent(a) ? auditScorePercent(a) : null;
      return {v:p, t:p==null ? '' : p+' %', h: p==null ? '<span class="muted">—</span>' : scorePercentHtml(a)}; }},
    {id:'ok', label:'OK', type:'text', cls:'dt-num', get:function(e){ return num(e[1].summary ? e[1].summary.ok||0 : null); }},
    {id:'nok', label:'NOK', type:'text', cls:'dt-num', get:function(e){ return num(e[1].summary ? e[1].summary.nok||0 : null); }},
    {id:'na', label:'N/A', type:'text', cls:'dt-num', get:function(e){ return num(e[1].summary ? e[1].summary.na||0 : null); }},
    {id:'corr', label:'Opatření', type:'text', cls:'dt-num', get:function(e){ return num((byAudit[e[0]]||[]).length); }},
    {id:'participants', label:'Zúčastněné osoby', type:'text', def:false, get:function(e){ return tblText(auditPresentNames(e[1]).join(', '), TBL_MAX.long); }},
    {id:'started', label:'Zahájení', title:'Datum zahájení', type:'date', def:false, get:function(e){ var a=e[1]; return {v:tsOf(a.startedAt), t:a.startedAt ? fmtDateShort(a.startedAt) : ''}; }},
    {id:'photos', label:'Fotky', title:'Počet fotek', type:'text', cls:'dt-num', def:false, get:function(e){
      var n = 0; (e[1].answers||[]).forEach(function(ans){ n += (ans.attachments||[]).length; (ans.subAnswers||[]).forEach(function(sa){ n += (sa.attachments||[]).length; }); });
      return num(n); }},
    {id:'status', label:'Stav', type:'select', get:function(e){
      var st = auditStatusFromItems(e[1], byAudit[e[0]]||[]), meta = AUDIT_STATUS_META[st];
      return {v:meta.label, t:meta.label, h:'<span class="badge '+meta.cls+'">'+meta.label+'</span>'}; }}
  ];
}
function correctiveTableColumns(){
  var today = new Date(); today.setHours(0,0,0,0);
  return [
    {id:'code', label:'ID', type:'text', get:function(it){ return {v:it.auditNumber!=null ? auditNoSortKey(it)+'-'+('0000'+(it.seq||0)).slice(-5) : null, t:it.code||'', h: it.code ? correctiveCodeHtml(it.code) : '<span class="muted">—</span>'}; }},
    {id:'desc', label:'Popis', type:'text', get:function(it){ return tblText(it.description, TBL_MAX.long, true); }},
    {id:'wp', label:'Pracoviště', type:'select', get:function(it){ return tblText(it.workplaceName, TBL_MAX.mid); }},
    {id:'br', label:'Provozovna', type:'select', get:function(it){ return tblText(it.branchName||'Sídlo firmy', TBL_MAX.mid); }},
    {id:'resp', label:'Odpovědná osoba', type:'select', get:function(it){ return tblText(it.responsible, TBL_MAX.name); }},
    {id:'due', label:'Termín', type:'date', get:function(it){
      var od = isCorrectiveOverdue(it);
      return {v:tsOf(it.dueDate, true), t:it.dueDate ? fmtDateShort(it.dueDate) : '', h: it.dueDate ? '<span'+(od?' style="color:var(--nok);font-weight:700"':'')+'>'+fmtDateShort(it.dueDate)+'</span>' : '<span class="muted">—</span>'}; }},
    {id:'late', label:'Po termínu', title:'Počet dní po termínu', type:'text', cls:'dt-num', get:function(it){
      if(!isCorrectiveOverdue(it)) return {v:null, t:'', h:'<span class="muted">—</span>'};
      var d = Math.max(1, Math.floor((today.getTime() - new Date(it.dueDate+'T00:00:00').getTime())/86400000));
      return {v:d, t:String(d), h:'<span style="color:var(--nok);font-weight:700">'+d+'</span>'}; }},
    {id:'status', label:'Stav', type:'select', get:function(it){ var t = CORRECTIVE_STATUS_LABELS[it.status]||it.status||''; return {v:CORRECTIVE_STATUS_RANK[it.status], t:t, h:correctiveStatusBadgeHtml(it.status)}; }},
    {id:'adate', label:'Datum auditu', type:'date', get:function(it){ return {v:tsOf(it.closedAt), t:it.closedAt ? fmtDateShort(it.closedAt) : ''}; }},
    {id:'anum', label:'Č. auditu', type:'text', cls:'dt-num', get:function(it){ return {v:auditNoSortKey(it), t:auditNoValue(it)}; }},
    {id:'type', label:'Druh auditu', type:'select', get:function(it){ return tblText(it.auditTypeName, TBL_MAX.mid); }},
    {id:'agroup', label:'Skupina auditů', type:'select', def:false, get:function(it){ return tblText(auditGroupOfType(it.auditTypeId), TBL_MAX.mid); }},
    {id:'auditor', label:'Auditor', type:'select', get:function(it){ return tblText(it.auditorName, TBL_MAX.name); }},
    {id:'question', label:'Otázka', type:'text', get:function(it){ return tblText(it.isFinding ? 'Volné zjištění' : (it.parentQuestionText || it.questionText), TBL_MAX.long); }},
    {id:'subq', label:'Podotázka', type:'text', def:false, get:function(it){ return tblText(it.parentQuestionText ? it.questionText : '', TBL_MAX.long); }},
    {id:'finding', label:'Zjištění', type:'text', def:false, get:function(it){ return tblText(it.finding, TBL_MAX.long); }},
    {id:'resolved', label:'Vyřešeno', title:'Datum vyřešení', type:'date', def:false, get:function(it){ var r = correctiveResolvedAt(it); return {v:tsOf(r), t:r ? fmtDateShort(r) : ''}; }},
    {id:'lastBy', label:'Změnil stav', title:'Kdo naposledy změnil stav', type:'select', def:false, get:function(it){
      var h = it.history||[], by = '';
      for(var i=h.length-1;i>=0;i--){ if(h[i] && h[i].status){ by = h[i].changedBy||''; break; } }
      return tblText(by, TBL_MAX.name); }}
  ];
}
function historyTableHtml(list, baseSig){
  return dataTableHtml({key:'history', cols:historyTableColumns(), list:list, baseSig:baseSig,
    rowClick:function(e){ return 'App.openTableRow(\'history\',\''+e[0]+'\')'; },
    noun:function(n){ return n===1 ? 'audit' : (n>=2 && n<=4 ? 'audity' : 'auditů'); }});
}
function correctiveTableHtml(list, baseSig){
  return dataTableHtml({key:'corrective', cols:correctiveTableColumns(), list:list, baseSig:baseSig,
    rowClick:function(it){ return 'App.openTableRow(\'corrective\',\''+it.key+'\')'; },
    noun:function(n){ return 'opatření'; }});
}
function renderHistory(){
  if(state.historyShowTrash){ renderHistoryTrash(); return; }
  // Uzavřené audity = záložka obrazovky Audity; na mobilu/tabletu se při
  // otevřeném detailu záhlaví se záložkami nezobrazuje (detail je stránka).
  var html = (state.historyDetailId && !isDesktopLayout()) ? '' : auditsHeadHtml('closed');
  var wps = sortedWorkplaces();
  var types = sortedAuditTypes();
  var auditors = historyAuditorOptions();
  var activeFilterCount = (state.historyFilterWp?1:0) + (state.historyFilterType?1:0) + (state.historyFilterGroup?1:0) + (state.historyFilterResult?1:0) +
    (state.historyFilterAuditor?1:0) + (state.historyFilterCorrectiveStatus?1:0) +
    (state.historyDateFrom?1:0) + (state.historyDateTo?1:0);

  // list-toolbar: na desktopu jede vyhledávání + Filtry/Řadit v jednom
  // řádku (na mobilu/tabletu zůstávají pod sebou — viz .list-toolbar v CSS).
  html += '<div class="list-toolbar">';
  html += '<div class="field" style="margin-bottom:10px">' +
    '<input id="historySearchInput" value="'+esc(state.historySearch||'')+'" placeholder="Hledat podle pracoviště, auditora, otázek, ID opatření…"/></div>';

  html += '<div class="filter-toggle-row">' +
    '<button type="button" class="filter-toggle-btn'+(state.historyFiltersOpen?' on':'')+'" onclick="App.toggleHistoryFiltersOpen()">'+ICONS.filter+' Filtry'+scopeBadgeHtml('history')+
    (activeFilterCount>0 ? '<span class="count-badge">'+activeFilterCount+'</span>' : '')+
    '</button>' +
    historyMoreMenuHtml() +
    (isTableView('history') && !state.historySelectMode ? '' : sortControlHtml('historySortSelect', HISTORY_SORT_OPTIONS, state.historySortBy, state.historySortDir, 'toggleHistorySortDir')) +
    listViewToggleHtml('history') +
    '</div>';
  html += '</div>';

  if(state.historyFiltersOpen){
    html += '<div class="filter-panel">' + (state.correctiveAuditFilter && state.view==='corrective' ? '' : scopeToggleHtml('history'));
    html += '<div class="filter-grid" style="margin-bottom:10px">' +
      wpFilterFieldsHtml('historyWpSelect', state.historyFilterWp, wps, 'App.setHistoryWpFilter(%s)') +
      auditGroupFilterFieldHtml('historyGroupSelect', state.historyFilterGroup) +
      '<div class="field"><label>Druh auditu</label>' +
      '<select class="filter-select" id="historyTypeSelect" '+(types.length===0?'disabled':'')+'><option value="">Všechny druhy</option>' +
      typesInGroup(types, state.historyFilterGroup).map(function(e){ return '<option value="'+e[0]+'" '+(state.historyFilterType===e[0]?'selected':'')+'>'+esc(e[1].name)+'</option>'; }).join('') +
      '</select></div>' +
      '<div class="field"><label>Auditor</label>' +
      '<select class="filter-select" id="historyAuditorSelect" '+(auditors.length===0?'disabled':'')+'><option value="">Všichni auditoři</option>' +
      auditors.map(function(n){ return '<option value="'+esc(n)+'" '+(state.historyFilterAuditor===n?'selected':'')+'>'+esc(n)+'</option>'; }).join('') +
      '</select></div></div>';

    html += '<div style="margin-bottom:10px"><label>Výsledek</label>' +
      '<div class="pill-select" style="margin-bottom:0;margin-top:4px">' +
      ['', 'OK', 'NOK'].map(function(r){
        var label = r===''?'Vše':r;
        return '<button type="button" class="'+(state.historyFilterResult===r?'on':'')+'" onclick="App.setHistoryResultFilter(\''+r+'\')">'+label+'</button>';
      }).join('') + '</div></div>';

    html += '<div style="margin-bottom:10px"><label>Stav opatření</label>' +
      '<div class="pill-select" style="margin-bottom:0;margin-top:4px">' +
      [['', 'Vše'], ['none','Bez opatření'], ['open','V řešení'], ['done','Vyřešena'], ['overdue','Po termínu']].map(function(o){
        return '<button type="button" class="'+(state.historyFilterCorrectiveStatus===o[0]?'on':'')+'" onclick="App.setHistoryCorrectiveStatusFilter(\''+o[0]+'\')">'+o[1]+'</button>';
      }).join('') + '</div></div>';

    html += '<div class="field-row" style="margin-bottom:0">' +
      '<div class="field field-date" style="margin-bottom:0"><label>Od</label>' +
      '<div class="date-wrap">'+dateTimeInputHtml({id:'historyDateFrom', value:state.historyDateFrom}) +
      '</div></div>' +
      '<div class="field field-date" style="margin-bottom:0"><label>Do</label>' +
      '<div class="date-wrap">'+dateTimeInputHtml({id:'historyDateTo', value:state.historyDateTo}) +
      '</div></div></div>';
    html += filterActionsHtml('clearHistoryFilters', 'history', !state.historyFilterWp && !state.historyFilterType && !state.historyFilterGroup && !state.historyFilterResult && !state.historyFilterAuditor && !state.historyFilterCorrectiveStatus && !state.historyDateFrom && !state.historyDateTo);
    html += '</div>';
  }

  var list = filteredHistoryList();

  // Stránka se vrátí na 1, jakmile se změní aktivní filtr/vyhledávání/řazení.
  var historySig = JSON.stringify([state.historyFilterWp, state.historyFilterType, state.historyFilterGroup, state.historyFilterResult,
    state.historyFilterAuditor, state.historyFilterCorrectiveStatus,
    state.historySearch, state.historyDateFrom, state.historyDateTo, state.historySortBy, state.historySortDir]);
  // Tabulkové zobrazení (desktop): tabulka, nebo detail jako samostatná stránka.
  if(isTableView('history') && !state.historySelectMode){
    if(state.historyDetailId){
      var tdHtml = historyDetailHtml(state.historyDetailId);
      if(tdHtml!=null){ document.getElementById('content').innerHTML = '<div class="table-detail-page">'+tdHtml+'</div>'; return; }
    }
    html += historyTableHtml(list, historySig);
    document.getElementById('content').innerHTML = html;
    wireHistoryToolbar();
    wireTableDateFilters('history', historyTableColumns());
    return;
  }
  var page = paginateList(list, 'historyPage', 'historyPageSig', historySig);
  var visibleList = page.items;

  function historyRowInfoHtml(a){
    return '<div style="font-weight:600;font-size:var(--fs-md)">'+esc(a.workplaceName)+
      (a.auditNumber!=null ? ' <span class="muted mono" style="font-weight:400;font-size:var(--fs-sm)">'+esc(auditNoLabel(a))+'</span>' : '')+'</div>' +
      '<div class="muted" style="font-size:var(--fs-sm)">'+esc(a.branchName||'Sídlo firmy')+' · '+fmtDateShort(a.closedAt)+'</div>' +
      '<div class="muted" style="font-size:var(--fs-sm)">'+esc(a.auditTypeName||'Audit')+' · '+esc(auditAuditorLabel(a))+'</div>' +
      (a.summary ? '<div class="muted" style="font-size:var(--fs-sm);margin-top:2px">'+
        ((a.answers||[]).length ? 'OK '+a.summary.ok+' · NOK '+a.summary.nok+' · N/A '+a.summary.na : '') +
        ((a.findings||[]).length || !(a.answers||[]).length ? ((a.answers||[]).length ? ' · ' : '')+esc(findingsCountText(a.findings)) : '') +
        (auditUsesPercent(a) && auditScorePercent(a)!=null ? ' · '+scorePercentHtml(a) : '') + '</div>' : '');
  }

  if(state.historySelectMode){
    var allShownSelected = list.length>0 && list.every(function(e){ return state.historySelectedIds.has(e[0]); });
    html += '<div class="select-bar"><span>Vybráno: <b>'+state.historySelectedIds.size+'</b></span>' +
      '<span style="display:flex;gap:4px">' +
      '<button type="button" class="btn btn-sm btn-ghost" onclick="App.historySelectAllShown('+(allShownSelected?'false':'true')+')">'+(allShownSelected?'Zrušit označení':'Označit vše ('+list.length+')')+'</button>' +
      '<button type="button" class="btn btn-sm btn-ghost" onclick="App.toggleHistorySelectMode()">Hotovo</button></span></div>';
  }
  if(list.length===0){
    html += '<div class="empty">'+ICONS.empty+'<p>Žádné audity neodpovídají filtru.</p></div>';
  } else {
    // Při řazení podle data se seznam dělí nadpisy po měsících.
    var byMonth = (state.historySortBy||'closedAt')==='closedAt';
    var lastMonth = null, rowInCard = 0;
    html += byMonth ? '' : '<div class="card">';
    visibleList.forEach(function(e){
      var id=e[0], a=e[1];
      var badge = auditResultBadgeHtml(a);
      if(byMonth){
        var d = a.closedAt ? new Date(a.closedAt) : null;
        var mk = d ? d.getFullYear()+'-'+d.getMonth() : '';
        if(mk!==lastMonth){
          if(lastMonth!==null) html += '</div>';
          html += '<div class="set-section"'+(lastMonth===null?' style="margin-top:0"':'')+'>'+(d ? MONTH_NAMES_CS[d.getMonth()]+' '+d.getFullYear() : 'Bez data')+'</div><div class="card">';
          lastMonth = mk; rowInCard = 0;
        }
      }
      html += (rowInCard++>0?'<div class="list-sep"></div>':'');
      if(state.historySelectMode){
        var checked = state.historySelectedIds.has(id);
        html += '<label class="list-item" style="width:100%;cursor:pointer;padding:2px">' +
          '<input type="checkbox" style="margin:0 12px 0 0" '+(checked?'checked':'')+' onchange="App.toggleHistorySelected(\''+id+'\')"/>' +
          '<div style="min-width:0;flex:1">'+historyRowInfoHtml(a)+auditCorrectiveLineHtml(id, false)+'</div>' + badge + '</label>';
      } else {
        html += '<div class="list-item" style="width:100%;cursor:pointer;padding:2px" onclick="App.openHistoryDetail(\''+id+'\')">' +
          '<div style="min-width:0">'+historyRowInfoHtml(a)+auditCorrectiveLineHtml(id, true)+'</div>' +
          '<div style="flex-shrink:0">' + badge + '</div></div>';
      }
    });
    html += '</div>';
    html += paginationControlsHtml('historyPage', page);
  }
  if(state.historySelectMode){
    var none = state.historySelectedIds.size===0;
    var bulkConfirm = confirmRow('bulkdelaudits', 'Smazat vybrané audity ('+state.historySelectedIds.size+')? Do '+DELETED_RETENTION_DAYS+' dní je půjde obnovit v Koši.', 'Smazat');
    html += '<div class="sticky-foot">' + (bulkConfirm ? '<div style="margin-bottom:8px">'+bulkConfirm+'</div>' : '') +
      '<div class="bulk-actions">' +
      '<button class="btn btn-primary" '+(none?'disabled':'')+' onclick="App.exportHistory(\'csv\',\'selected\')">CSV souhrn</button>' +
      '<button class="btn" '+(none?'disabled':'')+' onclick="App.exportHistory(\'csvnok\',\'selected\')">CSV NOK</button>' +
      (canManageContent() ? '<button class="btn btn-danger" '+(none?'disabled':'')+' onclick="App.askConfirm(\'bulkdelaudits\', App.deleteSelectedAudits)">'+ICONS.trash+' Smazat</button>' : '') +
      '</div></div>';
  }
  // Split-view pilot (Historie auditů): na desktopu (≥1024px) jsou seznam
  // a detail vedle sebe; na mobilu/tabletu se chování nezměnilo — buď
  // seznam, nebo detail (přepíná se třídou has-detail, viz CSS).
  var hasDetail = !!state.historyDetailId;
  var detailHtml = hasDetail ? historyDetailHtml(state.historyDetailId) : null;
  if(hasDetail && detailHtml==null){
    // historyDetailHtml() si při neplatném id samo vynulovalo
    // state.historyDetailId — znovu vykreslit už jen jako prázdný detail.
    renderHistory();
    return;
  }
  if(!hasDetail){
    detailHtml = '<div class="split-detail-empty"><p class="muted">Vyberte audit ze seznamu.</p></div>';
  }
  html = '<div class="split-view'+(hasDetail?' has-detail':'')+'"><div class="split-list">' + html + '</div>' +
    '<div class="split-detail">' + detailHtml + '</div></div>';
  document.getElementById('content').innerHTML = html;
  wireHistoryToolbar();
}
function wireHistoryToolbar(){
  var searchEl = document.getElementById('historySearchInput');
  if(searchEl) searchEl.addEventListener('input', function(){ state.historySearch = searchEl.value; render(); });
  var fromEl = document.getElementById('historyDateFrom');
  wireDateFilter(fromEl, 'historyDateFrom');
  var toEl = document.getElementById('historyDateTo');
  wireDateFilter(toEl, 'historyDateTo');
  var wpSelEl = document.getElementById('historyWpSelect');
  if(wpSelEl) wpSelEl.addEventListener('change', function(){ App.setHistoryWpFilter(wpSelEl.value); });
  var typeSelEl = document.getElementById('historyTypeSelect');
  if(typeSelEl) typeSelEl.addEventListener('change', function(){ App.setHistoryTypeFilter(typeSelEl.value); });
  var groupSelEl = document.getElementById('historyGroupSelect');
  if(groupSelEl) groupSelEl.addEventListener('change', function(){ App.setHistoryGroupFilter(groupSelEl.value); });
  var auditorSelEl = document.getElementById('historyAuditorSelect');
  if(auditorSelEl) auditorSelEl.addEventListener('change', function(){ App.setHistoryAuditorFilter(auditorSelEl.value); });
  var sortSelEl = document.getElementById('historySortSelect');
  if(sortSelEl) sortSelEl.addEventListener('change', function(){ App.setHistorySortBy(sortSelEl.value); });
}
function renderHistoryTrash(){
  var html = settingsHeadHtml('Koš', 'Smazané audity zůstávají tady '+DELETED_RETENTION_DAYS+' dní, pak se trvale odstraní.', null, 'App.closeTrash()');
  var list = deletedAudits();
  if(list.length===0){
    html += '<div class="empty">'+ICONS.empty+'<p>Koš je prázdný.</p></div>';
  } else {
    var emptyConfirm = confirmRow('emptytrash', 'Trvale smazat všechny audity v koši ('+list.length+') včetně jejich fotek a nápravných opatření? Akci už nelze vrátit.', 'Vysypat koš', 'btn-danger');
    html += emptyConfirm ? '<div style="margin-bottom:12px">'+emptyConfirm+'</div>' :
      '<button class="btn btn-danger btn-block" style="margin-bottom:12px" onclick="App.askConfirm(\'emptytrash\', App.emptyTrash)">'+ICONS.trash+' Vysypat koš ('+list.length+')</button>';
    var trPage = paginateList(list, 'trashPage');
    html += '<div class="card">';
    trPage.items.forEach(function(e, i){
      var id = e[0], a = e[1];
      var ageDays = daysSince(a.deletedAt) || 0;
      var remaining = Math.max(0, DELETED_RETENTION_DAYS - ageDays);
      var confirm = confirmRow('purge:'+id, 'Trvale smazat tento audit? Akci už nelze vrátit.', 'Smazat trvale', 'btn-danger');
      html += (i>0?'<div class="list-sep"></div>':'');
      html += '<div style="padding:2px">';
      html += '<div style="min-width:0;margin-bottom:6px">' +
        '<div style="font-weight:600;font-size:var(--fs-md)">'+esc(a.workplaceName)+'</div>' +
        '<div class="muted" style="font-size:var(--fs-sm)">'+esc(a.branchName||'Sídlo firmy')+'</div>' +
        '<div class="muted" style="font-size:var(--fs-sm)">'+esc(a.auditTypeName||'Audit')+' · '+esc(auditAuditorLabel(a))+'</div>' +
        '<div class="muted" style="font-size:var(--fs-sm);margin-top:2px">Smazáno '+fmtDateShort(a.deletedAt)+' · zbývá '+remaining+' dn'+(remaining===1?'en':(remaining>=2&&remaining<=4?'y':'í'))+'</div></div>';
      if(confirm){
        html += confirm;
      } else {
        html += '<div style="display:flex;gap:8px">' +
          '<button class="btn btn-sm btn-primary" onclick="App.restoreAudit(\''+id+'\')">Obnovit</button>' +
          '<button class="btn btn-sm btn-ghost btn-danger" onclick="App.askConfirm(\'purge:'+id+'\', function(){App.purgeAuditPermanently(\''+id+'\')})">'+ICONS.trash+' Smazat trvale</button>' +
          '</div>';
      }
      html += '</div>';
    });
    html += '</div>' + paginationControlsHtml('trashPage', trPage);
  }
  document.getElementById('content').innerHTML = html;
}
App.setHistoryWpFilter = function(v){ state.historyFilterWp = v; render(); };
App.setHistoryTypeFilter = function(v){ state.historyFilterType = v; render(); };
App.setHistoryGroupFilter = function(v){
  state.historyFilterGroup = v;
  if(v && state.historyFilterType && !matchesAuditGroup(state.historyFilterType, v)) state.historyFilterType = '';
  render();
};
App.setHistoryResultFilter = function(v){ state.historyFilterResult = v; render(); };
App.setHistoryAuditorFilter = function(v){ state.historyFilterAuditor = v; render(); };
App.setHistoryCorrectiveStatusFilter = function(v){ state.historyFilterCorrectiveStatus = v; render(); };
App.setHistorySortBy = function(v){
  var opt = HISTORY_SORT_OPTIONS.find(function(o){ return o.id===v; });
  state.historySortBy = v;
  state.historySortDir = opt ? opt.defaultDir : 'desc';
  render();
};
App.toggleHistorySortDir = function(){
  state.historySortDir = state.historySortDir==='asc' ? 'desc' : 'asc';
  render();
};
App.toggleHistoryFiltersOpen = function(){ state.historyFiltersOpen = !state.historyFiltersOpen; render(); };
// Z Moje úkoly ("+ N dalších" u pracovišť): Historie — audity
// s opatřeními po termínu na všech mých pracovištích.
App.openMyOverdueAudits = function(){
  App.openWorkplaceOverdueAudits('');
};
App.openWorkplaceOverdueAudits = function(wid){
  state.historyFilterWp = wid;
  state.historyFilterType = ''; state.historyFilterGroup = '';
  state.historyFilterResult = '';
  state.historyFilterAuditor = '';
  state.historyFilterCorrectiveStatus = 'overdue';
  state.historyDateFrom = '';
  state.historyDateTo = '';
  state.historySearch = '';
  state.historyDetailId = null;
  state.historyShowTrash = false;
  state.historyFiltersOpen = false; // odkaz nastaví filtr, panel filtrů zůstane zabalený
  // „Moje“ v Historii = jen moje audity; audity mého pracoviště prováděli
  // i jiní → přepnout na „Moje pracoviště“ (štítek na tlačítku Filtry).
  setScopeSilent('history', 'workplaces');
  state.view = 'history';
  render();
};
// toDefault: výchozí nastavení (Moje), jinak vše zrušit (Vše).
App.clearHistoryFilters = function(toDefault){
  setScopeSilent('history', toDefault ? 'mine' : 'all');
  state.historyFilterWp = '';
  state.historyFilterType = ''; state.historyFilterGroup = '';
  state.historyFilterResult = '';
  state.historyFilterAuditor = '';
  state.historyFilterCorrectiveStatus = '';
  state.historyDateFrom = '';
  state.historyDateTo = '';
  render();
};
// returnTo (optional), same idea as App.openCorrectiveDetail's: lets
// "Zpět na historii" go back to wherever this detail was opened from
// (e.g. {view:'corrective', correctiveDetailId:key} from the "Otevřít
// audit" button in an opatření's detail) instead of always landing on
// the plain history list.
App.openHistoryDetail = function(id, returnTo){
  state.view = 'history';
  state.historyDetailId = id;
  state.historyDetailReturnTo = returnTo || null;
  render();
};
// Soft delete: the audit (and its corrective-action records) stay in the
// database with a deletedAt stamp, so it disappears from Historie/Dashboard
// (closedAudits() filters it out) but can still be restored from the Koš
// for DELETED_RETENTION_DAYS, after which maybePurgeOldDeletedAudits removes
// it for good via hardDeleteAudit.
// deleteAudit/restoreAudit/purgeAuditPermanently all used to only queue the
// write and wait for it to come back through the realtime subscription
// (write → change notification → full re-fetch of the whole audits table →
// render()) before the list visibly updated — a few real round trips even
// on a fast connection, so the click felt like it did nothing for seconds.
// They now update this client's own copy of state.audits immediately and
// render() right away; the background write/refresh just confirms it and
// is what every other device picks up.
App.deleteAudit = function(id){
  if(!db) return;
  var deletedAt = new Date().toISOString();
  var a = state.audits.get(id);
  if(a) a.deletedAt = deletedAt;
  queueWrite(function(){
    return db.doc('audits/'+id).update({deletedAt: deletedAt});
  });
  showToast('Audit přesunut do koše. Po '+DELETED_RETENTION_DAYS+' dní ho můžete obnovit v Historii → Koš.');
  render();
};
App.restoreAudit = function(id){
  if(!db) return;
  var a = state.audits.get(id);
  if(a) a.deletedAt = null;
  queueWrite(function(){
    return db.doc('audits/'+id).update({deletedAt: null});
  });
  showToast('Audit obnoven.');
  render();
};
App.purgeAuditPermanently = function(id){
  // Capture what the cascade will need to clean up BEFORE the optimistic
  // local delete below removes the audit's answers/attachments from
  // state — see cascadeDeleteAudits' comment on `precollected`.
  var precollected = {
    caKeys: correctiveActionKeysForAudits([id]),
    attachmentIds: collectAttachmentIdsForAudits([id])
  };
  state.audits.delete(id);
  hardDeleteAudit(id, precollected);
  showToast('Audit trvale smazán.');
  render();
};
// Vysypat koš: trvale smaže všechny audity v koši (aktuální firma) i s fotkami
// a záznamy opatření — stejně jako "Smazat trvale" u jednotlivého auditu.
App.emptyTrash = function(){
  if(!db || !canManageContent()) return;
  var ids = deletedAudits().map(function(e){ return e[0]; });
  if(!ids.length) return;
  var precollected = { caKeys: correctiveActionKeysForAudits(ids), attachmentIds: collectAttachmentIdsForAudits(ids) };
  ids.forEach(function(id){ state.audits.delete(id); });
  queueWrite(function(){ return cascadeDeleteAudits(ids, precollected); });
  showToast('Koš vysypán — trvale smazáno: '+ids.length+'.');
  render();
};
App.openTrash = function(){ state.historyShowTrash = true; state.confirmTarget=''; render(); };
App.closeTrash = function(){ state.historyShowTrash = false; state.confirmTarget=''; render(); };
// Vrací HTML detailu auditu jako string (nezapisuje do DOM) — používá ji
// renderHistory() pro split-view pilot (seznam + detail vedle sebe na
// desktopu, přepínání na mobilu/tabletu). Vrátí null při neplatném id;
// volající pak sám state.historyDetailId vynuluje a znovu vykreslí.
function historyDetailHtml(id){
  var a = state.audits.get(id);
  if(!a){ state.historyDetailId=null; return null; }
  var isDesktop = !!(window.matchMedia && window.matchMedia('(min-width:1024px)').matches);
  var html = '<div class="view-head"><div class="row-between" style="margin-bottom:10px;flex-wrap:wrap;gap:8px">' +
    '<button class="btn btn-sm btn-ghost" onclick="App.backFromDetail()">'+detailBackLabel('history')+'</button>' +
    '<div style="display:flex;gap:6px;flex-wrap:wrap">' +
    '<button class="btn btn-sm" id="pdfExportBtn" onclick="App.exportAuditPdf(\''+id+'\')">'+ICONS.download+' PDF</button>' +
    (canManageContent() ? '<button class="btn btn-sm btn-ghost btn-danger" onclick="App.askConfirm(\'delaudit:'+id+'\', function(){App.deleteAudit(\''+id+'\');App.backFromDetail();})">'+ICONS.trash+' Smazat</button>' : '') +
    '</div></div>' +
    (canManageContent() ? (confirmRow('delaudit:'+id, 'Smazat tento audit? Po '+DELETED_RETENTION_DAYS+' dní ho půjde obnovit v Historii → Koš.', 'Smazat', 'btn-danger') || '') : '') +
    '<h2 style="font-size:var(--fs-2xl)">'+esc(a.workplaceName)+
    (a.auditNumber!=null ? ' <span class="muted mono" style="font-size:var(--fs-lg);font-weight:400">'+esc(auditNoLabel(a))+'</span>' : '')+
    '</h2><p>'+esc(a.auditTypeName||'Audit')+'</p></div>';
  html += '<div class="card detail-head"><dl class="kv">' +
    (a.auditNumber!=null ? '<dt>Číslo auditu</dt><dd class="mono">'+esc(auditNoValue(a))+'</dd>' : '') +
    '<dt>Provozovna</dt><dd>'+esc(a.branchName||'Sídlo firmy')+'</dd>' +
    '<dt>Druh auditu</dt><dd>'+esc(a.auditTypeName||'—')+'</dd>' +
    '<dt>Auditor</dt><dd>'+esc(auditAuditorLabel(a))+'</dd>' +
    (auditPresentNames(a).length ? '<dt>Zúčastněné osoby</dt><dd>'+esc(auditPresentNames(a).join(', '))+'</dd>' : '') +
    (auditAbsentNames(a).length ? '<dt>Nepřítomní</dt><dd>'+esc(auditAbsentNames(a).join(', '))+'</dd>' : '') +
    '<dt>Zahájeno</dt><dd>'+fmtDate(a.startedAt)+'</dd>' +
    '<dt>Uzavřeno</dt><dd>'+fmtDate(a.closedAt)+'</dd>' +
    ((a.answers||[]).length ? '<dt>Výsledek</dt><dd>'+(auditUsesOkNok(a) ? (a.summary && a.summary.overall==='OK' ? '<span class="badge badge-ok">OK</span>' : '<span class="badge badge-nok">NOK</span>') : '') +
    ' <span class="muted mono" style="font-size:var(--fs-sm)">OK '+a.summary.ok+' · NOK '+a.summary.nok+' · N/A '+a.summary.na+'</span>' +
    (auditUsesPercent(a) && auditScorePercent(a)!=null ? ' ' + scorePercentHtml(a, {size:'13px'}) : '') + '</dd>' : '') +
    (((a.answers||[]).length===0 || (a.findings||[]).length) ? '<dt>Zjištění</dt><dd>'+esc(findingsCountText(a.findings))+'</dd>' : '') +
    '</dl></div>';

  var byGroup = new Map(); var order=[];
  (a.answers||[]).forEach(function(ans){
    if(!byGroup.has(ans.groupId)){ byGroup.set(ans.groupId,{name:ans.groupName,items:[]}); order.push(ans.groupId); }
    byGroup.get(ans.groupId).items.push(ans);
  });
  order.forEach(function(gid){
    var grp = byGroup.get(gid);
    html += '<div class="group-section"><div class="group-head" style="cursor:default"><div class="title">'+esc(grp.name)+'</div></div><div class="group-body">';
    grp.items.forEach(function(ans){
      var badge = ans.result==='OK' ? '<span class="badge badge-ok">OK</span>' :
        ans.result==='NOK' ? '<span class="badge badge-nok">NOK</span>' :
        ans.result==='NA' ? '<span class="badge badge-na">N/A</span>' : '<span class="badge badge-neutral">—</span>';
      html += '<div class="q-row"><div class="row-between" style="align-items:flex-start"><div class="q-text" style="flex:1;margin-bottom:0">'+esc(ans.questionText)+'</div>'+badge+'</div>';
      if(ans.note){ html += '<div class="note-view"><span class="note-view-label">Zjištění</span>'+esc(ans.note)+'</div>'; }
      if(ans.attachments && ans.attachments.length){
        html += '<div class="photo-row">' + ans.attachments.map(function(att){
          return '<div class="photo-thumb"><img loading="lazy" decoding="async" src="'+att.url+'" onclick="App.viewPhoto(\''+att.url+'\')"/></div>';
        }).join('') + '</div>';
      }
      if(ans.result==='NOK'){
        html += correctiveReadOnlyHtml(ans.correctiveAction, id, ans.id, null);
      }
      if(ans.subAnswers && ans.subAnswers.length){
        html += '<div style="margin:6px 0 0 10px;padding-left:10px;border-left:2px solid var(--border)">';
        ans.subAnswers.forEach(function(sa){
          var sbadge = sa.result==='OK' ? '<span class="badge badge-ok">OK</span>' :
            sa.result==='NOK' ? '<span class="badge badge-nok">NOK</span>' :
            sa.result==='NA' ? '<span class="badge badge-na">N/A</span>' : '<span class="badge badge-neutral">—</span>';
          html += '<div class="row-between" style="padding:4px 0"><div style="font-size:var(--fs-base);flex:1">'+esc(sa.text)+'</div>'+sbadge+'</div>';
          if(sa.note){ html += '<div class="note-view"><span class="note-view-label">Zjištění</span>'+esc(sa.note)+'</div>'; }
          if(sa.attachments && sa.attachments.length){
            html += '<div class="photo-row">' + sa.attachments.map(function(att){
              return '<div class="photo-thumb"><img loading="lazy" decoding="async" src="'+att.url+'" onclick="App.viewPhoto(\''+att.url+'\')"/></div>';
            }).join('') + '</div>';
          }
          if(sa.result==='NOK'){
            html += correctiveReadOnlyHtml(sa.correctiveAction, id, ans.id, sa.id);
          }
        });
        html += '</div>';
      }
      html += '</div>';
    });
    html += '</div></div>';
  });
  html += findingsReadOnlyHtml(a, id);
  return html;
}
// Volná zjištění uzavřeného auditu (detail v Historii).
function findingsReadOnlyHtml(a, id){
  var list = a.findings || [];
  if(!list.length) return '';
  var html = '<div class="group-section"><div class="group-head" style="cursor:default"><div class="title">'+((a.answers||[]).length ? 'Volná zjištění' : 'Zjištění')+'</div></div><div class="group-body">';
  list.forEach(function(f, i){
    var good = f.result==='GOOD';
    html += '<div class="q-row"><div class="row-between" style="align-items:flex-start"><div class="q-text" style="flex:1;margin-bottom:0">Zjištění '+(i+1) +
      (f.workplaceId && f.workplaceId!==a.workplaceId ? ' <span class="muted" style="font-weight:400">· '+esc(f.workplaceName||'')+'</span>' : '')+'</div>' +
      (good ? '<span class="badge badge-ok">Dobrá praxe</span>' : '<span class="badge badge-nok">Neshoda</span>')+'</div>';
    if(f.note) html += '<div class="note-view"><span class="note-view-label">Popis</span>'+esc(f.note)+'</div>';
    if(f.attachments && f.attachments.length){
      html += '<div class="photo-row">' + f.attachments.map(function(att){
        return '<div class="photo-thumb"><img loading="lazy" decoding="async" src="'+att.url+'" onclick="App.viewPhoto(\''+att.url+'\')"/></div>';
      }).join('') + '</div>';
    }
    if(!good) html += correctiveReadOnlyHtml(f.correctiveAction, id, f.id, null);
    html += '</div>';
  });
  return html + '</div></div>';
}
App.backFromDetail = function(){
  var returnTo = state.historyDetailReturnTo;
  state.historyDetailId = null;
  state.historyDetailReturnTo = null;
  if(returnTo && returnTo.view==='corrective' && returnTo.correctiveDetailId){
    state.view = 'corrective';
    state.correctiveDetailId = returnTo.correctiveDetailId;
  }
  render();
};

export {
  correctiveTableColumns,
  correctiveTableHtml,
  detailBackLabel,
  isTableView,
  listViewToggleHtml,
  renderHistory,
  wireTableDateFilters
};
